import { ComponentType, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiCommission } from 'src/http';
import { Page } from '../page';
import BasicTable from './BasicTable';

export interface Commission {
  id?: string | number;
  publicId?: string;
  appType?: null | number | string;
  title: {
    ru: string;
    uz: string;
    oz: string;
  };
}

export const Commissions: ComponentType = () => {
  const [data, setData] = useState<Commission[] | null>(null);
  const [total, setTotal] = useState<number>(0);
  const getCommissions = async (page?: string) => {
    let params = {
      skip: page && Number(page) > 0 ? (Number(page) - 1) * 10 : 0,
      take: 10,
    };
    try {
      const data = await ApiCommission.fetchAll(params);
      setData(data.hits);
      setTotal(Math.ceil(data.total / 10));
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const createItem = async (item: Commission) => {
    try {
      await ApiCommission.createOne(item);
      setData(null);
      getCommissions();
    } catch ({ message }: any) {
      console.log(message);
    }
  };
  const updateItem = async (item: Commission) => {
    try {
      await ApiCommission.updateOne(item.id || 0, item);
      setData(null);
      getCommissions();
    } catch ({ message }: any) {
      console.log(message);
    }
  };

  const changePagination = (page: string) => {
    getCommissions(page);
  };

  useEffect(() => {
    getCommissions();
  }, []);

  const { t } = useTranslation();
  return (
    <Page title={t('commissions', 'Список комиссий')}>
      <BasicTable
        data={data}
        createItem={createItem}
        updateItem={updateItem}
        changePagination={changePagination}
        total={total}
      />
    </Page>
  );
};
